import { createPortal } from 'react-dom';

const spinnerKeyframes = `
@keyframes gcat-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
@keyframes gcat-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}
`;

function LoadingModal({ loading, message = 'Carregando dados...' }) {
    if (!loading) return null;

    return createPortal(
        <>
            <style>{spinnerKeyframes}</style>
            <div
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.65)',
                    backdropFilter: 'blur(4px)',
                    zIndex: 9999,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <div
                    style={{
                        background: '#fff',
                        borderRadius: '12px',
                        padding: '2.5rem 3rem',
                        textAlign: 'center',
                        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
                        minWidth: '280px',
                    }}
                >
                    <div
                        style={{
                            width: '56px',
                            height: '56px',
                            border: '4px solid #e0e0e0',
                            borderTop: '4px solid #13489c',
                            borderRadius: '50%',
                            animation: 'gcat-spin 0.8s linear infinite',
                            margin: '0 auto 1.25rem',
                        }}
                    />
                    <p
                        style={{
                            margin: 0,
                            fontSize: '0.95rem',
                            fontWeight: 500,
                            color: '#333',
                            animation: 'gcat-pulse 1.5s ease-in-out infinite',
                        }}
                    >
                        {message}
                    </p>
                    <p
                        style={{
                            margin: '0.35rem 0 0',
                            fontSize: '0.8rem',
                            color: '#888',
                        }}
                    >
                        Por favor, aguarde
                    </p>
                </div>
            </div>
        </>,
        document.body
    );
}

export default LoadingModal;
